export const errorClassToSeverityMapping = {
  info: ['UserFeedback'],
};

export const ignoreErrorClasses = ['UndoError'];
export const ignoreErrorMessages = ['View closed with a rejection'];

export const errorClassToGroupMapping = {
  UserFeedback: ['UserFeedback'],
  NetworkError: ['NetworkError'],
  ApolloError: ['ApolloError'],
};

export default { errorClassToSeverityMapping, errorClassToGroupMapping, ignoreErrorClasses };
